"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsAlarmPeriodEnum = void 0;
var StatsAlarmPeriodEnum;
(function (StatsAlarmPeriodEnum) {
    StatsAlarmPeriodEnum["LIVE_TODAY"] = "LIVE_TODAY";
    StatsAlarmPeriodEnum["TODAY"] = "TODAY";
    StatsAlarmPeriodEnum["LAST_24_HOURS"] = "LAST_24_HOURS";
    StatsAlarmPeriodEnum["THIS_WEEK"] = "THIS_WEEK";
    StatsAlarmPeriodEnum["THIS_WEEK_SUN"] = "THIS_WEEK_SUN";
    StatsAlarmPeriodEnum["THIS_MONTH"] = "THIS_MONTH";
    StatsAlarmPeriodEnum["LAST_7_DAYS"] = "LAST_7_DAYS";
})(StatsAlarmPeriodEnum = exports.StatsAlarmPeriodEnum || (exports.StatsAlarmPeriodEnum = {}));
